function initCarousel() {
	if ($('.js-carousel').length) {
		$('.js-carousel').slick({
			infinite: true,
			autoplay: true,
  			autoplaySpeed: 4000,
  			speed: 1000,
  			cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  			dots: true,
  			arrows: true,
  			pauseOnHover: false,
  			prevArrow:'<a class="slick-prev"><i class="icon icon-arrow-left"></i></a>',
    		nextArrow:'<a class="slick-next"><i class="icon icon-arrow-right"></i></a>',
        responsive: [
        {
          breakpoint: 1100,
          settings: {
            arrows: false,
          }
        }]
		});
    $('.js-carousel').on('breakpoint', function(){
      $(this).find('.js-async-bg').addClass('not-loaded');
      asyncBg();
    });
	}
  if ($('.js-carousel-fade').length) {
    $('.js-carousel-fade').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1000,
      fade: true,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      dots: false,
      arrows: false,
      pauseOnHover: true,
    });
  }
}